<template>
  <SelectComponent
    v-model="selectedValues"
    :values="statusOptions"
    :label="label"
    :required="required"
    name="status"
    colored
    :errors="errors"
    :edition-mode="editionMode"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { computed } from 'vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent'
import Status from "../../../assets/enums/invoicing/Status";

export default {
  name: 'SelectInvoiceStatuses',
  components: { SelectComponent },
  props: {
    editionMode: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: [Array, Number],
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: () => $t('attributes.status')
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const selectedValues = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    })
    return { selectedValues }
  },
  computed: {
    ...mapGetters({
      invoice: 'invoicing/getInvoice',
      invoice_doc_types: 'metadata/getInvoiceDocTypes'
    }),
    statusOptions() {
      let available_statuses =
        this.invoice_doc_types.find(
          (type) => type.id === this.invoice?.doc_type
        )?.available_statuses ?? []
      if (this.invoice.status !== Status.DRAFT) {
        return available_statuses.filter((item) => item.id !== Status.DRAFT)
      }
      return available_statuses
    },
  }
}
</script>
